import { useAtomValue } from 'jotai'
import React from 'react'

import { surveyIdAtom } from '../../atoms'

export const useMainQueryKey = () => {
  const surveyId = useAtomValue(surveyIdAtom)

  return React.useMemo(
    () => ['SurveyFilterInformation_Main', { surveyId }],
    [surveyId],
  )
}
